function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", {
  id: "pay_icon_svg__defs11"
}, /*#__PURE__*/React.createElement("style", {
  id: "style9"
}, ".pay_icon_svg__b{fill:currentColor}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(.002)",
  id: "pay_icon_svg__g21"
}, /*#__PURE__*/React.createElement("path", {
  className: "pay_icon_svg__b",
  d: "M13.771 5.652a8.117 8.117 0 108.115 8.118 8.126 8.126 0 00-8.115-8.118zm.429 12.075v.236a.49.49 0 11-.979 0v-.231a2.8 2.8 0 01-2.261-1.144.72.72 0 01.623-1.088h.072a.728.728 0 01.643.4 1.259 1.259 0 00.924.613v-2.089l-.427-.1a2.168 2.168 0 01-1.97-2.146c0-1.266.885-2.094 2.4-2.259v-.343a.49.49 0 01.979 0v.342a2.7 2.7 0 012.066 1.135.721.721 0 11-1.267.686 1.133 1.133 0 00-.8-.583v1.986l.479.094c1.364.3 2.045 1.006 2.045 2.162-.007 1.329-.916 2.162-2.527 2.329z",
  transform: "translate(-5.654 -5.652)",
  id: "pay_icon_svg__path15"
}), /*#__PURE__*/React.createElement("path", {
  className: "pay_icon_svg__b",
  d: "M50.222 52.388v1.921c.642-.068 1.018-.421 1.018-.961 0-.495-.325-.804-1.018-.96z",
  transform: "translate(-41.68 -43.417)",
  id: "pay_icon_svg__path17"
}), /*#__PURE__*/React.createElement("path", {
  className: "pay_icon_svg__b",
  d: "M40.64 35.227c0 .434.3.74.858.893v-1.789a.928.928 0 00-.858.896z",
  transform: "translate(-33.935 -28.821)",
  id: "pay_icon_svg__path19"
}));
var SvgPayIcon = function SvgPayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.234,
    height: 16.234,
    id: "pay_icon_svg__svg25"
  }, props), _ref, _ref2);
};
export default SvgPayIcon;